module.exports = __webpack_public_path__ + "static/media/281065.37824b12.png";